module.exports = __webpack_public_path__ + "static/about-insta-3@2x-02db74b368802921d5a0e2a26e5e1bd6.jpg";